import { render, staticRenderFns } from "./Disclosure.vue?vue&type=template&id=29ab8580&scoped=true"
import script from "./Disclosure.vue?vue&type=script&lang=ts"
export * from "./Disclosure.vue?vue&type=script&lang=ts"
import style0 from "./Disclosure.vue?vue&type=style&index=0&id=29ab8580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ab8580",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxDisclosureIconWithText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/DisclosureIconWithText.vue').default})
